import { titleToToolPreviewTypeMap, titleToToolImageMap, titleToToolDescriptionMap, titleToToolTypeMap } from '../../toolsMapping';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import ToolCard from './toolCard';
import './tools.css'

export const Tools = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  // Build the full tool list with all necessary props
  const toolList = Object.entries(titleToToolTypeMap).map(([title, type]) => ({
    title,
    type,
    image: titleToToolImageMap[title],
    previewType: titleToToolPreviewTypeMap[title],
    tagline: titleToToolDescriptionMap[title],
  }));

  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      
      const section = sectionRef.current;
      const rect = section.getBoundingClientRect();
      
      // Adjust visibility threshold for mobile
      const visibilityThreshold = isMobile ? window.innerHeight * 0.8 : window.innerHeight;
      const isVisible = rect.top < visibilityThreshold && rect.bottom >= 0;
      
      if (isVisible) {
        section.classList.add('animate-section');
      }
    };

    // Run once on component mount with a slight delay to ensure proper rendering
    setTimeout(handleScroll, 100);
    
    // Use passive listener for better performance on mobile
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile]);

  return (
    <section id="tools" ref={sectionRef}>
      <div className="tools-container">
        <div className="tools-section-title fade-in">
          <h2>TEACHING TOOLS</h2>
          <p>Explore AI-powered tools for modern Islamic learning.</p>
        </div>

        <div className="tools-grid">
          {toolList.map((tool, i) => (
            <div 
              className={`tool-card-container ${isMobile ? 'mobile' : ''} slide-up-${i + 1}`} 
              key={i}
            >
              <ToolCard
                title={tool.title}
                icon={tool.image}
                previewType={tool.previewType}
                tagline={tool.tagline}
                onClick={() => navigate(`/tools/${tool.type}`)}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
